const BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:7777";

const getToken = () => localStorage.getItem("gc_token");

export const API = {
  get: async (url) => {
    const res = await fetch(BASE_URL + url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken() ? `Bearer ${getToken()}` : undefined
      }
    });

    if (res.status === 401) {
      throw new Error("Unauthorized");
    }

    if (!res.ok) throw new Error("API Error"); 
    return res.json();
  },

  post: async (url, body) => {
    const res = await fetch(BASE_URL + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken() ? `Bearer ${getToken()}` : undefined
      },
      body: JSON.stringify(body)
    });

    if (!res.ok) throw new Error("API Error");
    return res.json();
  }
};